import { render } from "./GptQuestionPanel.vue?vue&type=template&id=00a2ba8c&scoped=true&ts=true"
import script from "./GptQuestionPanel.vue?vue&type=script&lang=ts"
export * from "./GptQuestionPanel.vue?vue&type=script&lang=ts"

import "./GptQuestionPanel.vue?vue&type=style&index=0&id=00a2ba8c&lang=scss&scoped=true"
import "./GptQuestionPanel.vue?vue&type=style&index=1&id=00a2ba8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a2ba8c"]])

export default __exports__